import { Context } from '../../utils/globals'

export interface Event {
  id: string
  title: string
  content: string
  startDate: string
  endDate: string
  location: string
  url: string
  image: string
  createdAt: string
  trashed: boolean
}

export default class UserAPI {
  url: string
  context: Context
  cache: {[eventId: number]: Event | undefined}

  constructor (context: Context) {
    this.context = context
    this.cache = {}
    const host = process.env.app_config_community_api_url
    this.url = host || 'http://api.dev.insided.com'
  }

  public async getEvent (eventId: number): Promise<Event> {
    const cached = this.cache[eventId]
    if (cached) return cached

    const res = await this.context.axios.get(`${this.url}/event/${eventId}`)
    this.cache[eventId] = res.data.result
    return res.data
  }
}
